import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, map } from 'rxjs/operators';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Observable} from 'rxjs/Observable';

import { CaseIdentifier } from '../shared/case-identifier';
import { CountyService } from '../shared/county.service';
import { JuvenileCase } from './juvenile-case';
import { JuvenilePartyNameSearchResponse } from './juvenile-party-name-search-response';
import { JuvenileSearchCase } from './juvenile-search-case';
import { JuvenileSearchResponse } from './juvenile-search-response';
import { JuvenileSearchConstants } from './juvenile-search-constants';
import { environment } from './../../environments/environment';
import { WrappedResponse } from '../shared/wrapped-response';
import { FileNumberUtil } from '../shared/file-number-util';

@Injectable()
export class JuvenileSearchService {

  static getJuvenileStartYear(): number {
    return 1966;
  }
  static getCurrentYear(): number {
    return new Date().getFullYear();
  }

  static getJuvenileSearchCriteriaDescription(searchForm: any, county: string, caseNumber: string, userName: string) {
    const criteria = [];

    if (!caseNumber && !county) {
      if (searchForm.counties && searchForm.searchBy === 'Name') {
        const countiesDescription =
          (searchForm.counties.length > 0 && searchForm.counties.length < CountyService.number_of_counties) ?
            searchForm.counties.join(', ') : 'ALL';
            if (countiesDescription !== 'ALL') {
              if (countiesDescription.indexOf(',') > -1) {
                criteria.push('Counties = "' + countiesDescription + '"');
              } else {
                criteria.push('County = "' + countiesDescription + '"');
              }
            }
      }

      if (searchForm.searchBy && searchForm.searchValue) {
        const searchText: string = JuvenileSearchService.normalizeNameInput(searchForm.searchValue.toUpperCase());
          if (searchForm.searchBy === 'Name') {
            criteria.push('Juvenile Name= "' +  JuvenileSearchService.formatName(searchText.trim()) + '"');
          }

          if (searchForm.searchBy === 'NCJoinNumber') {
            criteria.push('NC-JOIN Number = "' + JuvenileSearchService.formatNcJoinNumber(searchText) + '"');
          }
      }

      if (searchForm.searchBy === 'Name') {
        // criteria.push('Case Years = "' + searchForm.fromYear + '" to "' + searchForm.toYear + '"');
        criteria.push('Case Years ="' + searchForm.fromYear + '" to "' + searchForm.toYear + '"');
        // criteria.push('to "' + searchForm.toYear +'"' );
      }
    } else {
      criteria.push('County = "' + county + '" | Case Number = "' + caseNumber + '"');
    }

    if (userName !== '') {
      // tslint:disable-next-line:quotemark
      criteria.push("Juvenile's Attorney Is " + userName);
    }

    const result = criteria.join('  | ');
    return result;
  }

  static formatNcJoinNumber(number: string): string {
    let temp: string = JuvenileSearchService.removeEmptySpaces(number);

    if (temp === '') {
      return temp;
    }

    switch (temp.length) {
      case 1:
        return  '000000' + temp;
      case 2:
        return  '00000' + temp;
      case 3:
        return  '0000' + temp;
      case 4:
        return  '000' + temp;
      case 5:
        return  '00' + temp;
      case 6:
        return  '0' + temp;
    }

    return temp;
  }

  static removeEmptySpaces(number: string): string {
    if (!number || number.trim() === '') {
      return '';
    }

    return number.replace(/\s/g, '');
  }

  static formatName(name: string): string {
    if (!name || name.trim() === '') {
      return '';
    }

    return name.replace(/\s+/, ' ');
  }

  private static normalizeNameInput(input: string): string {
    const str = input || '';
    return str.replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
  }

  constructor(private http: HttpClient) { }

  findByCaseIdentifier(caseIdentifier: CaseIdentifier): Observable<JuvenileCase> {
    const url = environment.proxyBaseUrl + 'juvenile_cases/' + caseIdentifier.county + '/' + caseIdentifier.caseNumber;
    return this.http.get<WrappedResponse>(url)
      .pipe(
        map((response) => new JuvenileCase(response.data)),
        catchError(this.handleError)
      );
  }

  juvenileSearch(searchForm: any, county: string, caseNumber: string): Observable<JuvenileSearchResponse> {
    const url = environment.proxyBaseUrl + 'juvenile_case_identities';
    let params = new HttpParams();

    if (!caseNumber && !county) {

      if (searchForm.searchBy === 'Name') {
        // Case Years - from and to
        const fromYear = searchForm.fromYear || JuvenileSearchService.getJuvenileStartYear();
        const toYear = searchForm.toYear || JuvenileSearchService.getCurrentYear();
        params = params.append('case_year_begin', fromYear);
        params = params.append('case_year_end', toYear);
      }

      if (searchForm.searchBy === 'Name') {
        if (searchForm.counties &&
              searchForm.counties.length &&
              searchForm.counties.length < CountyService.number_of_counties) {
            const countiesDescription = searchForm.counties.join(',');
            params = params.append('counties', countiesDescription);
          }
      }

      if (searchForm.searchBy === 'Name') {
       // if(searchForm.searchValue !== null) {
          // let name: string =  JuvenileSearchService.formatName(searchForm.searchValue.trim());
          let name: string =  JuvenileSearchService.normalizeNameInput(searchForm.searchValue.trim());
          params = params.append('juvenile_name', name);
        // }
      } else if (searchForm.searchBy === 'NCJoinNumber') {
        let ncJoinNumber: string = JuvenileSearchService.formatNcJoinNumber(searchForm.searchValue);
        params = params.append('nc_join', ncJoinNumber);
      }

      const pageNumber = searchForm.casesPageNumber || 1;

      params = params.append('page', pageNumber);
      params = params.append('size', JuvenileSearchConstants.PAGE_SIZE.toString());
    } else {
      params = params.append('county', county);
      params = params.append('case_number', JuvenileSearchService.removeEmptySpaces(caseNumber));
    }

    if (!environment.production) {
      console.log('URL=' + url + '?' + params);
    }
 // return this.http.get("assets/juvenile_search_results.json")
  // return this.http.get(url)
  return this.http.get<JuvenilePartyNameSearchResponse>(url, { params, observe: 'response' })
        .pipe(
            map( response => this.buildJuvenileSearchResponse(response)),
            // catchError(this.handleError)
            catchError( function(error: HttpErrorResponse) {

              let serverError: string;
              // TODO: if this error handling is consistent across all http calls,
              // we can push this code to CiprsHttp and avoid repeating the logic
              let errorMessage: string;
              if (params.toString().indexOf('juvenile_name') > -1) {
                serverError = 'No Juvenile records found for Juvenile Name, "' + params.get('juvenile_name') + '"';
              }

              if (params.toString().indexOf('nc_join') > -1) {
                serverError = 'No Juvenile records found for NC-JOIN Number, "' + params.get('nc_join') + '"';
              }

              if (params.toString().indexOf('case_number') > -1) {
                serverError = 'No Juvenile records found for case number, ' + params.get('case_number');
              }

              if (error.status === 0 ||
                  error.status >= 500) {
                console.log('error code = ' + error.status, error);
                errorMessage = 'Unable to retrieve Juvenile records at this time. Please try again later.';
                // Unable to reach the server. Please try again later.';
              } else {
                const wrappedErrorResponse = error.error || {};
                if (wrappedErrorResponse.responseCode === 403) {
                  // tslint:disable-next-line:max-line-length
                  errorMessage = 'Sorry, your account is not authorized to view these records. Please contact the AOC Help Desk to troubleshoot this issue.';
                } else if (wrappedErrorResponse.responseCode === 404) {
                  errorMessage = serverError;
                } else {
                 // errorMessage = 'The server encountered an error'; // TODO: what should the user be directed to do?
                 errorMessage = 'Unable to retrieve Juvenile records at this time. Please try again later.';
                }
              }
              console.log('errorMessage=' + errorMessage);
              return new ErrorObservable(errorMessage);
            })
        );
  }



  private handleError(error: HttpErrorResponse) {
    // TODO: if this error handling is consistent across all http calls,
    // we can push this code to CiprsHttp and avoid repeating the logic
    let errorMessage: string;
    if (error.status === 0 ||
        error.status >= 500) {
      console.log('error code = ' + error.status, error);
      errorMessage = 'Unable to retrieve Juvenile records at this time. Please try again later.';
      // Unable to reach the server. Please try again later.';
    } else {
      const wrappedErrorResponse = error.error || {};
      if (wrappedErrorResponse.responseCode === 404) {
        errorMessage = 'No matching records were found.';
      } else {
      //  errorMessage = 'The server encountered an error'; // TODO: what should the user be directed to do?
        errorMessage = 'Unable to retrieve Juvenile records at this time. Please try again later.';
      }
    }
    console.log('errorMessage=' + errorMessage);
    return new ErrorObservable(errorMessage);
  }

  // TODO: 20180327 this doesn't look compatible with paging
  private buildJuvenileSearchResponse(response: HttpResponse<JuvenilePartyNameSearchResponse>) {
    const data: any = response.body.data || [];
    const juvenileSearchCases = data.map(c => new JuvenileSearchCase(c));
    const pagingData = this.getPagingData(response.headers);

    const result: JuvenileSearchResponse = {
      cases: juvenileSearchCases,
      pageNumber: pagingData ? pagingData.pageNumber : -1, // not used, since the backend doesn't return it
      pageSize: pagingData ? pagingData.pageSize : -1, // not used, since the backend doesn't return it
      totalRecords: pagingData ? pagingData.totalRecords : juvenileSearchCases.length
    };

    if (!environment.production) {
      console.log(`Search Result = ${result.cases.length}`);
    }

    return result;
  }

  // format ->    101-150/211
  private getPagingData(httpHeaders: HttpHeaders): {pageNumber: number, pageSize: number, totalRecords: number} | undefined {
    const contentRangeHeader = httpHeaders.get('content-range') || '';
    const matches = contentRangeHeader.match(/(\d+)-(\d+)\/(\d+|\*)/);
    if (matches) {
      const matchNumbers = matches.slice(1).map(v => Number(v)); // throw away first element, convert to numbers
      const [firstRecord, lastRecord, totalRecords] = matchNumbers;
      const pageSize = (lastRecord - firstRecord) + 1; // e.g. (150 - 101) + 1 = 50
      const pageNumber = Math.ceil(firstRecord / pageSize); // e.g. Math.ceil(101 / 50) = 3
      return {
        pageNumber,
        pageSize,
        totalRecords
      }
    } else {
      return undefined;
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-search.service.ts